import { render } from "./DemographicsChart.vue?vue&type=template&id=bb053f58&scoped=true"
import script from "./DemographicsChart.vue?vue&type=script&lang=js"
export * from "./DemographicsChart.vue?vue&type=script&lang=js"

import "./DemographicsChart.vue?vue&type=style&index=0&id=bb053f58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb053f58"]])

export default __exports__